import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { isNil, omitBy } from 'lodash-es';
import { useTheme } from '@emotion/react';
import { memo } from 'react';
import Typography from '../../Typography/index.js';
import { Truncated } from '../../Truncated/index.js';
import useEllipsis from '../../useEllipsis/index.js';
const colorToThemeColor = (theme) => ({
    blue: theme.primaryAccentColor,
    white: theme.primaryBackgroundColor,
    gray: theme.secondaryDataColor
});
const Action = memo(({ style, children, maxLines, color = 'gray', transform = 'uppercase', truncatedView = 'tooltip', ...restProps }) => {
    const { ref, isTruncated } = useEllipsis(maxLines);
    const theme = useTheme();
    const customStyles = typeof style === 'function' ? style(theme) : style;
    function render(truncatedStyles) {
        return (_jsx(Typography, { ...restProps, ref: ref, style: theme => ({
                fontSize: '1.2rem',
                fontWeight: 600,
                lineHeight: 1.5,
                letterSpacing: 1,
                textTransform: transform,
                color: colorToThemeColor(theme)[color],
                ...truncatedStyles,
                ...omitBy(customStyles, v => isNil(v) || v === '')
            }), children: children }));
    }
    if (isTruncated) {
        return (_jsx(Truncated, { content: children, view: truncatedView, maxLines: maxLines, children: truncatedStyles => render(truncatedStyles) }));
    }
    return render();
});
export default Action;
//# sourceMappingURL=index.js.map